import { render, staticRenderFns } from "./RevisionEntryCreate.vue?vue&type=template&id=4fa6d00c&scoped=true"
import script from "./RevisionEntryCreate.vue?vue&type=script&lang=js"
export * from "./RevisionEntryCreate.vue?vue&type=script&lang=js"
import style0 from "./RevisionEntryCreate.vue?vue&type=style&index=0&id=4fa6d00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6d00c",
  null
  
)

export default component.exports